<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-list-item v-if="listItem" v-on="on" :disabled="!email">
        <v-list-item-title>
          {{ email ? "Email Invoice" : "No Customer Email" }}
        </v-list-item-title>
      </v-list-item>
      <v-btn
        v-else
        rounded
        text
        small
        :fab="$vuetify.breakpoint.xsOnly"
        v-on="on"
        color="blue-grey"
        dark
      >
        <span v-if="!$vuetify.breakpoint.xsOnly">Email</span>
        <v-icon :right="!$vuetify.breakpoint.xsOnly" small dark
          >mdi-email</v-icon
        >
      </v-btn>
    </template>

    <v-card>
      <ModelTitle title="Send Mail" @close="dialog = false" />

      <v-container grid-list-lg>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                :error-messages="emailErrors"
                :hide-details="emailErrors.length === 0" 
                v-model="Email"
                @focus="$event.target.select()"
                label="Email"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :error-messages="ccErrors"
                :hide-details="ccErrors.length === 0" 
                v-model="cc"
                @focus="$event.target.select()"
                label="Cc"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :error-messages="subjectErrors"
                :hide-details="subjectErrors.length === 0" 
                v-model="subject"
                @focus="$event.target.select()"
                label="Subject"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text>
          <div v-html="viewHtml"></div>
        </v-card-text>
      </v-container>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="mail()"> Send </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import customerService from "@/modules/Customer/service";
import invoiceService from "@/modules/Invoice/service";
import Hashids from "hashids";
const hashids = new Hashids();
const { validationMixin } = require("vuelidate");
const { required, minLength, email } = require("vuelidate/lib/validators");

export default {
  name: "send-email",
  props: [
    "email",
    "type",
    "id",
    "displayId",
    "name",
    "postfix",
    "obj",
    "listItem",
    "balance",
    "dueDate",
  ],
  data() {
    return {
      dialog: false,
      subject: null,
      viewHtml: null,
      url: null,
      Email: null,
      cc: null,
    };
  },
  computed: {
    subjectErrors() {
      const errors = [];
      if (!this.$v.subject.$dirty) return errors;
      if (!this.$v.subject.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.subject.minLength)
        errors.push("Subject must be at least 10 characters long");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.Email.$dirty) return errors;
      if (!this.$v.Email.email)
        errors.push("Email is not valid");
      if (!this.$v.Email.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    ccErrors() {
      const errors = [];
      if (!this.$v.cc.$dirty) return errors;
      if (!this.$v.cc.email)
        errors.push("cc is not valid");
      return errors;
    },
  },
  mixins: [validationMixin],
  validations: {
    subject: {
      required,
      minLength: minLength(10),
    },
    Email: {
      email,
      required,
    },
    cc: {
      email,
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.Email = this.email
        const invoiceNumber = this.displayId || this.id;
        const customerName = this.obj && this.obj.name ? this.obj.name : "Customer";
        const formattedBalance = Number(this.balance || 0).toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
        const formattedDueDate = this.dueDate
          ? this.$moment(this.dueDate).format("L")
          : null;

        this.subject = `Invoice #${invoiceNumber} from ${this.name}`;
        const hashId = hashids.encode(this.id);

        this.url = `${process.env.VUE_APP_FE_URL}/public/${this.type}/${hashId}/${this.postfix}`;

        this.viewHtml = `<html><body style="margin:0;padding:24px;background:#f5f7fa;font-family:Arial,sans-serif;color:#172033;">
              <table role="presentation" width="100%" cellspacing="0" cellpadding="0"><tr><td align="center">
              <table role="presentation" width="100%" cellspacing="0" cellpadding="0" style="max-width:600px;background:#ffffff;border:1px solid #e2e8f0;border-radius:12px;padding:32px;">
              <tr><td>
              <h2 style="margin:0 0 20px;">Invoice #${invoiceNumber}</h2>
              <p>Hello ${customerName},</p>
              <p>Your invoice from <strong>${this.name}</strong> has a balance of <strong>${formattedBalance}</strong>${formattedDueDate ? ` due on <strong>${formattedDueDate}</strong>` : " due now"}.</p>
              <p>Please use the button below to view your invoice.</p>
                <table width="100%" border="0" cellspacing="0" cellpadding="0">
                <tr>
                  <td>
                    <table border="0" cellspacing="0" cellpadding="0">
                      <tr>
                        <td>
                          <a href="${this.url}" target="_blank" style="font-size:16px;font-family:Arial,sans-serif;color:#ffffff;text-decoration:none;border-radius:6px;background-color:#1976d2;border:12px solid #1976d2;display:inline-block;">View Invoice</a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
              <p style="margin-top:20px;font-size:13px;color:#64748b;">If the button does not work, copy and paste this link into your browser:<br><a href="${this.url}" target="_blank">${this.url}</a></p>
              <p style="margin-top:24px;">Thank you for your business,<br><strong>${this.name}</strong></p>
              <div style="margin-top:28px;padding-top:18px;border-top:1px solid #e2e8f0;text-align:center;font-size:12px;color:#64748b;">Powered by <a href="https://smplsale.com" style="color:#1976d2;text-decoration:none;font-weight:bold;">SMPL Sale</a></div>
              </td></tr></table></td></tr></table></body></html>`;
      }
    },
  },
  methods: {
    async mail() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        let data = {
          to: this.Email,
          subject: this.subject,
          html: this.viewHtml,
        };
        if (this.cc) {
          data.cc = this.cc
        }
        // // console.log('obj', obj)
        const sendRequest = this.type === "invoice"
          ? invoiceService.sendEmail(this.id, data)
          : customerService.sendEmail(data);
        try {
          await sendRequest.then((response) => {
          console.log('response sendEmail', response)
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: `Email was send successfully to ${data.to}`,
            });
            this.$emit("sent");
          });
        } catch (error) {
          const message =
            (error && error.data && error.data.message) ||
            "The invoice email could not be sent.";
          this.$swal("Email Invoice", message, "error");
          return;
        }

        this.dialog = false;
      }
    },
  },
};
</script>

<style scoped></style>
